import { render, staticRenderFns } from "./RecipientInfo.vue?vue&type=template&id=f56902bc&scoped=true&"
import script from "./RecipientInfo.vue?vue&type=script&lang=js&"
export * from "./RecipientInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecipientInfo.vue?vue&type=style&index=0&id=f56902bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56902bc",
  null
  
)

export default component.exports